module.exports = __webpack_public_path__ + "img/e3b34c582b3c0832c38845a6619dfdde.png";